import mapLayers from "./mapLayers"
import routeTypes from "./routeTypes"
import planRoute from "./planRoute"
import manualRoute from "./manualRoute"
import compareRoutes from "./compareRoutes"

export const TOURS = [mapLayers, routeTypes, planRoute, manualRoute, compareRoutes]
